<template>
  <v-card>
    <v-card-title class="role-card-title">
      <span v-text="isCreateMode ? t.addRole : t.editRole" />
    </v-card-title>
    <v-card-text>
      <v-form
        ref="form"
        v-model="isFormValid"
        @input="$emit('update:isFormValid', isFormValid)"
      >
        <v-text-field
          data-qa="role-name-input"
          v-model="roleName"
          :label="t.roleName"
          filled required clearable
          class="mt-5 role-textfield"
          :counter="limits.roleNameMax"
          :disabled="!isCreateMode"
          :color="primaryColor"
          :rules="[
            rules.required, rules.alphanumeric,
            rules.maxLengthRule(limits.roleNameMax), rules.minLengthRule(limits.roleNameMin)
          ]"
        />
        <v-textarea
          data-qa="role-description-input"
          v-model="roleDescription"
          :label="t.roleDescription"
          filled required clearable
          class="mt-3 role-textfield"
          :counter="limits.roleDescriptionMax"
          :color="primaryColor"
          :rules="[rules.required, rules.maxLengthRule(limits.roleDescriptionMax)]"
        />
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'RoleInput',
  props: {
    value: {
      type: Object,
      default: () => ({ roleName: '', roleDescription: '' })
    },
    isCreateMode: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isFormValid: false,
      original: {
        roleName: '',
        roleDescription: ''
      }
    }
  },
  created () {
    this.original.roleName = this.value?.roleName ?? ''
    this.original.roleDescription = this.value?.roleDescription ?? ''
  },
  computed: {
    isDirty () {
      return this.original.roleName !== this.roleName ||
        this.original.roleDescription !== this.roleDescription
    },
    limits () {
      return {
        roleNameMax: 50,
        roleNameMin: 4,
        roleDescriptionMax: 240
      }
    },
    rules () {
      return {
        required: v => !!v || this.t.required,
        alphanumeric: v => /^[a-zA-Z][a-zA-Z0-9_]*$/.test(v) || this.t.alphanumericError,
        minLengthRule: minLength => v => v.length >= minLength || this.t.minLengthError(minLength),
        maxLengthRule: maxLength => v => v.length <= maxLength || this.t.maxLengthError(maxLength)
      }
    },
    roleName: {
      get () { return this?.value?.roleName ?? '' },
      set (newValue) { this.$emit('input', { ...this.value, roleName: newValue }) }
    },
    roleDescription: {
      get () { return this?.value?.roleDescription ?? '' },
      set (newValue) { this.$emit('input', { ...this.value, roleDescription: newValue }) }
    },
    t () {
      return {
        addRole: this.$t('roleMaintenance.addRole'),
        editRole: this.$t('roleMaintenance.editRole'),
        roleName: this.$t('roleMaintenance.roleName'),
        roleDescription: this.$t('roleMaintenance.roleDescription'),
        required: this.$t('errors.common.required'),
        alphanumericError: this.$t('roleMaintenance.alphanumericError'),
        maxLengthError: v => this.$t('roleMaintenance.maxLengthError', { v }),
        minLengthError: v => this.$t('roleMaintenance.minLengthError', { v })
      }
    }
  },
  watch: {
    isDirty: {
      immediate: true,
      handler (val) {
        this.$emit('update:isDirty', val)
      }
    }
  }
}
</script>
